import { render, staticRenderFns } from "./GoodsManagement.vue?vue&type=template&id=239b6fb6&scoped=true"
import script from "./GoodsManagement.vue?vue&type=script&lang=js"
export * from "./GoodsManagement.vue?vue&type=script&lang=js"
import style0 from "./GoodsManagement.vue?vue&type=style&index=0&id=239b6fb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "239b6fb6",
  null
  
)

export default component.exports